import { StorageClient } from '../../configParametersRepository/storageClient/types';
import { fireDataLayerEvent } from '../tag-commander/datalayer';
import { createConfigParametersRepository } from '../../configParametersRepository';

export const createDatalayerTrackingClient = ({
  storageClient,
}: {
  storageClient: StorageClient;
}) => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const trackingStorageClient = getTrackingStorageClient();
  if (storageClient) {
    //TODO: the storageClient param is no longer needed
  }
  return {
    trackEvent: fireDataLayerEvent,
    save: (item) => {
      trackingStorageClient.update('tcDatalayer', (datalayer) => ({
        ...datalayer,
        ...item,
      }));
    },
  };
};
